import { AllRestrictionsReceivedRecord } from "actions/regulation/types";
import { CurbLinkRecord, defaultCurbLinkRecord } from "interfaces/CurbLink";
import { GeoserverLinkProperties } from "interfaces/Geoserver";
import { eachLinkRecord } from "../../components/curb/map/deckgl/interfaces";

export const GET_LINK_RESTRICTION = "GET_LINK_RESTRICTION";
export const LINK_RESTRICTION_RECEIVED = "LINK_RESTRICTION_RECEIVED";
export const TOGGLE_RIGHT1_PANEL = "TOGGLE_RIGHT1_PANEL";
export const GET_SOURCE_IDS = "GET_SOURCE_IDS";
export const RECEIVED_SOURCE_IDS = "RECEIVED_SOURCE_IDS";
export const TOGGLE_SEGMENT_INFO_EXPANDED = "TOGGLE_SEGMENT_INFO_EXPANDED";

export interface GetLinkRestrictionParams {
    date: string;
    fields: string;
}

export interface LinkRestrictionState {
    isRightSideBar1Open: boolean;
    isLinkRestrictionFetched: boolean;
    linkRestrictionData: GetLinkRestrictionDefaultData | null;
    isSegmentInfoExpanded: boolean;
    sourceIds: ReceivedSourceIdsInterface;
}

export const defaultLinkRestrictionData = {
    ...defaultCurbLinkRecord,
    timeData: {}
};

export const defaultSourceIdValues = {
    meta: {
        count: 0,
        next: "",
        previous: ""
    },
    results: []
};

export interface TimeDataRecord {
    [param: string]: TimeDataInterface[];
}

export interface TimeDataInterface extends AllRestrictionsReceivedRecord {
    day: string;
    regulation: {
        price: string;
        time_limit: string;
        payment?: {
            duration?: Array<number>;
            fees?: Array<number>;
        };
        id: number;
        by_law_info: {
            bylaw_number: null | string;
            created: string;
            id: number;
            modified: string;
            schedule_name: string;
        };
        sub_activity: {
            activity: {
                name: string;
                id: number;
            };
            color: string;
            display_name: string;
            icon: null | string;
            name: string;
            id: number;
        };
    };
}

export interface GetLinkRestrictionDefaultData extends CurbLinkRecord {
    sno?: number;
    timeData: TimeDataRecord;
    actual_regulation_id?: number;
    selected?: boolean;
    disabled?: boolean;
    properties?: GeoserverLinkProperties;
}

export interface ReceivedSourceIdsInterface {
    meta: {
        count: number;
        next: string;
        previous: string;
    };
    results: {
        sensor_type_1: {
            source_id: string;
        };
    }[];
}

export interface GetLinkRestriction {
    type: typeof GET_LINK_RESTRICTION;
    payload: {
        id: number;
        defaultData: GetLinkRestrictionDefaultData | eachLinkRecord;
        params: GetLinkRestrictionParams;
        timeData?: TimeDataRecord;
    };
}

export interface LinkRestrictionReceived {
    type: typeof LINK_RESTRICTION_RECEIVED;
    payload: { data: GetLinkRestrictionDefaultData };
}

export interface ToggleRight1Panel {
    type: typeof TOGGLE_RIGHT1_PANEL;
    payload: { isOpen: boolean };
}

export interface GetSourceIds {
    type: typeof GET_SOURCE_IDS;
    payload: { linkId: number };
}

export interface ReceivedSourceIds {
    type: typeof RECEIVED_SOURCE_IDS;
    payload: { sourceIds: ReceivedSourceIdsInterface };
}

export interface ToggleSegmentInfoExpanded {
    type: typeof TOGGLE_SEGMENT_INFO_EXPANDED;
    payload: { isSegmentInfoExpanded: boolean };
}

export type LinkRestrictionTypes =
    | GetLinkRestriction
    | LinkRestrictionReceived
    | ToggleRight1Panel
    | GetSourceIds
    | ReceivedSourceIds
    | ToggleSegmentInfoExpanded;
